<template>
  <span :class="badgeClass" class="email-log-status-badge">
    <i :class="iconClass" class="mr-2"></i>
    {{ statusText }}
  </span>
</template>

<script>
export default {
  name: "EmailLogStatusBadge",
  props: {
    status: {
      type: String,
      required: true
    },
    statusDisplay: {
      type: String,
      default: ""
    }
  },
  computed: {
    badgeClass() {
      const classes = {
        sent: "badge-sent",
        pending: "badge-pending",
        failed: "badge-failed"
      };
      return classes[this.status] || "badge-default";
    },
    iconClass() {
      const icons = {
        sent: "fa-solid fa-check-circle",
        pending: "fa-solid fa-clock",
        failed: "fa-solid fa-exclamation-circle"
      };
      return icons[this.status] || "fa-solid fa-circle";
    },
    statusText() {
      return this.statusDisplay || this.getDefaultStatusText();
    }
  },
  methods: {
    getDefaultStatusText() {
      const texts = {
        sent: "Enviado",
        pending: "Pendente",
        failed: "Falha"
      };
      return texts[this.status] || this.status;
    }
  }
};
</script>

<style lang="scss" scoped>
.email-log-status-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;

  &.badge-sent {
    background-color: rgba(72, 187, 120, 0.1);
    color: #2f855a;
  }

  &.badge-pending {
    background-color: rgba(237, 137, 54, 0.1);
    color: #c05621;
  }

  &.badge-failed {
    background-color: rgba(245, 101, 101, 0.1);
    color: #c53030;
  }

  &.badge-default {
    background-color: rgba(160, 174, 192, 0.1);
    color: #4a5568;
  }

  i {
    font-size: 12px;
  }
}
</style>
